<template>
  <div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" :class="isMobile?'loginBox':'login-form'">
      <h3 :class="isMobile?'titleBox':'title'"> DMS 货主端 </h3>
      <hr :class="isMobile?'solidBox':'hr-solid'"  />
      <el-form-item prop="username">
        <el-input  v-model="loginForm.username" type="text" auto-complete="off" placeholder="手机号">
          <svg-icon slot="prefix" icon-class="user"  class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="loginForm.fromPlatform == 15">
        <el-input  v-model="loginForm.code" auto-complete="off" placeholder="验证码" @keyup.enter.native="handleLogin">
          <div slot="suffix" :class="isMobile?'validCodeBox':'validCode'" @click="getCode" v-if="!disabled">{{ codeMsg }}</div>
          <div slot="suffix" :class="isMobile?'validCodeBox1':''" v-else>{{ codeMsg }}</div>
          <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password" v-if="loginForm.fromPlatform == 10">
        <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="密码"
          @keyup.enter.native="handleLogin">
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="warehouseNo" v-if="identification">
        <el-select v-model="ownerList" value-key="customerNo" filterable placeholder="请选择货主" @change="ownerChange"
          style="width: 100%">
          <el-option v-for="item in ownerNoList" :key="item.customerNo" :label="item.name" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <div :class="isMobile?'agreementBox':'agreement'" class="agreement">
        <el-checkbox v-model="rememberMe" style="line-height: 0; color: #000;"></el-checkbox>
        我已阅读并同意
        <span @click="open = true">《蜂腾隐私协议》</span>
      </div>
      <el-form-item>
        <el-button :loading="loading" size="medium" type="primary" :class="isMobile?'buttonBox':'button'"  @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
      <el-form-item>
        <div :class="isMobile?'footerBox':'footer'">
          <div>联系我们<span :class="isMobile?'iphoneBox':'iphone'"> 400-6280-680</span></div>
          <div :class="isMobile?'verificationBox':'verification'"  @click="loginForm.fromPlatform = loginForm.fromPlatform == 10 ? 15 : 10">{{
            loginForm.fromPlatform == 10 ? '验证码登录' :
            '密码登录' }}</div>
        </div>
        <div :class="isMobile?'registerBox':'register'">没有账号？
          <a class="link-type" href="https://www.fengtengkeji.com/register" target="_blank">立即注册</a>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="open" ref="second"  :class="isMobile?'my-dialogBox':'my-dialog'" >
      <iframe src="https://www.fengtengkeji.com/statics/sys/user/蜂腾系统协议.html" frameborder="0" width="100%"
        height="500"></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        fromPlatform: 10,
        fromSource: 20,
      },
      loginRules: {
        username: [
          {
            required: true,
            message: "账号不能为空",
            trigger: "blur",
          },
          {
            validator: (rule, value, cb) => {
              if (/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)) {
                cb();
              } else {
                cb(new Error("手机号格式错误"));
              }
            },
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      ownerList: {},
      loading: false,
      codeMsg: '获取验证码',
      identification: false,
      disabled: false,
      rememberMe: false,
      open:false,
      countdown: 60,
    }
  },
  methods: {
    getCode() {
      this.$refs.loginForm.validateField("username", async (valid) => {
        if (!valid) {
          let res = await this.$http.get(
            "https://dmsapi.fengtengjituan.cn/prod-api/code",
            {
              headers: {
                loginType: 1,
                phoneNum: this.loginForm.username,
              },
            }
          );
          if (res.data.code == 200) {
            this.$message({ message: "验证码已发送", type: "success" });
            this.disabled = true;
            this.timer = setInterval(() => {
              this.countdown--;
              this.codeMsg = this.countdown + "s";
              if (this.countdown === 0) {
                clearInterval(this.timer);
                this.codeMsg = "获取验证码";
                this.disabled = false;
                this.countdown = 60;
              }
            }, 1000);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        }
      });
    },
    ownerChange(val) {
      this.loginForm.ownerNo = val.customerNo;
      this.loginForm.ownerName = val.name;
      this.login()
    },
    handleLogin() {
      if (!this.rememberMe) {
        return this.$message({ message: "请先阅读并同意《蜂腾隐私协议》", type: "error" });
      }
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let res = await this.$http.post(
            "https://dmsapi.fengtengjituan.cn/prod-api/auth/getLoginSceneByUsername",
            {
              username: this.loginForm.username,
              fromSource: 20,
              fromPlatform: 10,
            }
          );
          if (res.data.code == 200) {
            if (
              this.loginForm.ownerNo ||
              res.data.data == null ||
              res.data.data.scene == "owner_tourist"
            ) {
              if (res.data.data.scene == "owner_tourist") {
                this.loginForm.role = "owner_tourist"

              }
              this.login()
            } else {
              this.identification = res.data.data.scene;
              this.ownerNoList = eval(res.data.data.sceneOptionselect);
              if (res.data.scene) {
                this.$message({ message: "请选择货主", type: "success" });
              }
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        }
      });
    },
    login() {
      let url =
        "https://www.fengtengkeji.com/toLogin?fromSource=20&username=" +
        this.loginForm.username +
        "&password=" +
        this.loginForm.password +
        "&code=" +
        this.loginForm.code +
        "&ownerNo=" +
        this.loginForm.ownerNo +
        "&fromPlatform=" +
        this.loginForm.fromPlatform +
        "&ownerName=" +
        this.loginForm.ownerName +
        "&role=" +
        this.loginForm.role;

      window.open(url, "_blank");
    }
  }
}
</script>

<style lang="scss">
.login-form {
  position: absolute;
  top: 259px;
  right: 283px;
  z-index: 2;
  text-align: left;
  width: 350px;
  padding: 25px 25px 5px 25px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;

  .title {
    margin-bottom: 5px;
    color: #fff;
    font-size: 20px
  }

  .hr-solid {
    margin-left: 0px;
    margin-bottom: 20px;
    width: 40%;
    border-top: 1px solid #FE5E00;
    // color: #FE5E00;
  }

  .button {
    width: 100%;
    background: #FE5E00;
    border-color: #FE5E00;
  }

  .validCode {
    color: #FE5E00;
    cursor: pointer;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    line-height: 15px;

    .iphone {
      font-weight: 800;
      font-size: 16px;
      color: #fff;
    }

    .verification {
      font-size: 14px;
      color: #FE5E00;
      cursor: pointer;
    }
  }

  .register {
    line-height: 20px;
    font-size: 11px;
    display: flex;
    justify-content: center;
    padding-top: 10px;

    a {
      font-weight: 800;
      font-size: 15px;
      color: #FE5E00;
    }
  }

  .agreement {
    line-height: 25px;
    font-size: 12px;

    span {
      color: #1E9FFF;
      cursor: pointer;
    }
  }
}


.loginBox {
  position: absolute;
  top: 1.63rem;
  right: 0.29rem;
  z-index: 2;
  text-align: left;
  width: 3.3rem;
  padding: 0.25rem;
  border-radius: 0.08rem;
  background:#fff;
  color: #000;
  border: 1px solid #AEAEAE;
  height: 3.25rem;

  .titleBox {
    margin-bottom: 0.06rem;
    color: #000;
    font-size: 0.18rem
  }

  .solidBox {
    margin-left: 0px;
    margin-bottom: 0.2rem;
    width: 41%;
    border-top: 0.02rem solid #FE5E00;
    // color: #FE5E00;
  }

  .buttonBox {
    width: 100%;
    height: 0.4rem;
    background: #FE5E00;
    border-color: #FE5E00;
   font-size: 0.13rem;
    color: #FFF9F9;
    border-radius: 0.06rem;
  }

  .validCodeBox {
    color: #FE5E00;
    cursor: pointer;
    font-size: 0.12rem;
    line-height: 0.38rem;
    margin-right: 0.2rem;
  }
    .validCodeBox1 {
    color: #ccc;
    cursor: pointer;
    font-size: 0.12rem;
    line-height: 0.38rem;
    margin-right: 0.2rem;
  }

  .footerBox {
    display: flex;
    justify-content: space-between;
    font-size: 0.08rem;
    line-height: 0.25rem;
    color: #A1A6AA;

    .iphoneBox {
      font-weight: bold;
      font-size: 0.14rem;
      color: #000;
    }

    .verificationBox {
      font-size: 0.1rem;
      color: #FE5E00;
      cursor: pointer;
    }
  }

  .registerBox {
    line-height: 0.2rem;
    font-size: 0.1rem;
    display: flex;
    justify-content: center;

    a {
      font-weight: bold;
      font-size: 0.13rem;
      color: #FE5E00;
    }
  }

  .agreementBox {
    font-size: 0.1rem;
    color: #A1A6AA;
    margin: 0.1rem 0;

    span {
      color: #1E9FFF;
      cursor: pointer;
    }
  }
}

.login-form .el-input__inner {
  color: #fff;
  background-color: rgba(0, 0, 0, 0);
  /* 你可以更换成你想要的颜色 */
  border-color: #fff;
  /* 同样可以更换边框颜色 */
 
}

.loginBox .el-input__inner {
 width: 2.65rem;
height: 0.38rem;
border-radius: 0.06rem;
border: 0.01rem solid #DFDFDF;
color: #868686;
font-size: 0.14rem;
margin-bottom: 0.1rem;
padding-left: 0.28rem;
 
}

.loginBox .el-form-item__error {
  font-size: 0.10rem;
   top: 83%;
}

.loginBox .el-checkbox__inner{
  width: 0.1rem;
  height: 0.09rem;
}


.my-dialog{
  position: absolute;
  font-size: 20px;
  top: 10%;
  .el-dialog{
    width: 700px;
    margin-left: 55%;
  }
}
.my-dialogBox{
  position: absolute;
  font-size: 0.1rem;
  left: 5%;
  top: 10%;
  margin: 0;
  .el-dialog{
    width: 89%;
  }

}

.loginBox .svg-icon[data-v-c8a70580]{
    width: 0.12rem;
    height: 0.4rem;
    margin-left: 0.09rem;

}
 
</style>